import { useEffect } from "react";
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import M from 'materialize-css/dist/js/materialize.min';
import { Link } from 'react-router-dom';
import whiteBg from '../../assets/white-poly.jpg';

const Sidenav = () => {
    
    let date = new Date().getFullYear();

    useEffect(() => {
        //==========
        let elems = document.querySelectorAll('.sidenav');
        M.Sidenav.init(elems, {});

        let item = document.querySelectorAll('.dropdown-trigger');
        M.Dropdown.init(item, { coverTrigger: false, hover: true });

        let item2 = document.querySelectorAll('.collapsible');
        M.Collapsible.init(item2, {});
        //=============
    }, []);
    return ( 
        <ul className="sidenav" id="mobile-nav">
            <li>
                <div className="user-view">
                    <div className="background">
                        <img src={whiteBg} alt="White Poly Background"/>
                    </div>
                    <Link to="/"> 
                        <img src="/img/logo.svg" alt="Life Long Education Logo" className="logo" />
                    </Link> 
                    <div><span className="grey-text text-darken-3 is-size-4-touch has-text-weight-bold">Life Long Polytechnic</span></div>
                </div>
            </li>
            <li className="home-link2">
                <Link to="/">
                    <i className="material-icons ">home</i>
                    <span><p className="">Home</p></span>
                </Link>
            </li>
            <li>
                <div className="divider"></div>
            </li>
            <li>
            <Link to="/admission">
                    <i className="material-icons">business</i>
                    <span><p className="">Admission</p></span>
                </Link>
            </li>
            <li>
                <div className="divider"></div>
            </li>
            <li>
                <Link to="/about">
                    <i className="material-icons ">location_city</i>
                    <span><p className="">About Us</p></span>
                </Link>
            </li>
            <li>
                <div className="divider"></div>
            </li>
            <li>
                <ul className="collapsible collapsible-accordion">
                    <li className="sidenav-s-link">
                        <a href="#!" className="collapsible-header container">
                            <i className="material-icons ">school</i>
                            <span className=" make-mont service-span">Students</span>
                            <i className="tiny material-icons  right">arrow_drop_down</i>
                        </a>
                        <div className="collapsible-body">
                            <ul>
                                <li>
                                    <Link to="/portal" className="wave-effect">Students Portal</Link>
                                    {/* <Link to="/sportsAndClubs" className="wave-effect">Sports &amp; Clubs</Link> */}
                                </li>
                            </ul>
                        </div>               
                    </li>
                </ul>
            </li>
            <li>
                <ul className="collapsible collapsible-accordion">
                    <li className="sidenav-s-link">
                        <a href="#!" className="collapsible-header container">
                            <i className="material-icons ">local_activity</i>
                            <span className=" make-mont service-span">Divisions</span>
                            <i className="tiny material-icons  right">arrow_drop_down</i>
                        </a>
                        <div className="collapsible-body">
                            <ul>
                                <li>
                                    <Link to="/division/aas" className="grey-text text-darken-2">Applied Arts &amp; Science</Link>
                                    <Link to="/division/ccd" className="grey-text text-darken-2">Civil &amp; Construction</Link>
                                    <Link to="/division/engineering" className="grey-text text-darken-2">Engineering</Link>
                                    <Link to="/division/commerce" className="grey-text text-darken-2">Commerce</Link>
                                    <Link to="/division/reed" className="grey-text text-darken-2">Education &amp; Enterprise Dev.</Link>
                                    <Link to="/shortcourses" className="grey-text text-darken-2">Short and Bridging Courses</Link>
                                </li>
                            </ul>
                        </div>               
                    </li>
                </ul>
            </li>
            <li>
                <div className="divider"></div>
            </li>
            <li>
                <Link to="/gallery">
                    <i className="material-icons ">list</i>
                    <span><p className="">Gallery</p></span>
                </Link>
            </li>
            <li>
                <div className="divider"></div>
            </li>
            <li>
                <Link to="/contact">
                    <i className="material-icons ">contact_phone</i>
                    <span><p className="">Contact Us</p></span>
                </Link>
            </li>
            <li>
                <div className="divider"></div>
            </li>
            <li className="center mt-3">
                <p className="grey-text text-lighten-1 small-text">Life Long Polytechnic &copy; {date}</p>
            </li>
        </ul>
     );
}
 
export default Sidenav;